import { render, staticRenderFns } from "./index.vue?vue&type=template&id=20c21d2f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=20c21d2f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c21d2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20c21d2f')) {
      api.createRecord('20c21d2f', component.options)
    } else {
      api.reload('20c21d2f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=20c21d2f&scoped=true", function () {
      api.rerender('20c21d2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/abnormalOrders/outOfStock/index.vue"
export default component.exports